<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_alertType') || '预警类型'"
            prop="alertType"
          >
            <dict-select
              v-model="formData.alertType"
              size="small"
              clearable
              filterable
              :body="{ dictType: 'alertType' }"
              url="/sys/common/dict/system"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_alertField') || '预警字段'"
            prop="alertField"
          >
            <dict-select
              v-model="formData.alertField"
              size="small"
              clearable
              filterable
              :body="{ dictType: 'alertField' }"
              url="/sys/common/dict/system"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_beforeTime') || '提前多少时间预警'"
            prop="beforeTime"
          >
            <el-input
              v-model="formData.beforeTime"
              :placeholder="
                $l('INDEX.tips_input_placeholder') || '提前多少时间预警'
              "
              size="small"
              maxlength="500"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_recipient') || '收件人'"
            prop="recipient"
          >
            <el-input
              v-model="formData.recipient"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="500"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_ccTo') || '抄送人'" prop="ccTo">
            <el-input
              v-model="formData.ccTo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="500"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    shipmentCustomerSettingCode: { type: String, default: '' },
    alertCode: { type: String, default: '' },
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {},
      rules: {
        recipient: [
          {
            required: false,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (value) {
                const emails = value.split(',')
                let result = true
                for (let i = 0; i < emails.length; i++) {
                  const reg = new RegExp(
                    /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                    'g'
                  )
                  console.log(emails[i])

                  const regRes = reg.test(emails[i])
                  console.log(regRes)
                  if (!regRes) {
                    result = false
                    break
                  }
                }
                console.log(result)
                if (result) {
                  callback()
                } else {
                  callback(new Error('请输入正确的邮箱'))
                }
              } else {
                callback()
              }
            },
          },
        ],
        ccTo: [
          {
            required: false,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (value) {
                const emails = value.split(',')
                let result = true
                for (let i = 0; i < emails.length; i++) {
                  const reg = new RegExp(
                    /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                    'g'
                  )
                  console.log(emails[i])

                  const regRes = reg.test(emails[i])
                  console.log(regRes)
                  if (!regRes) {
                    result = false
                    break
                  }
                }
                console.log(result)
                if (result) {
                  callback()
                } else {
                  callback(new Error('请输入正确的邮箱'))
                }
              } else {
                callback()
              }
            },
          },
        ],
        alertType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        alertField: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        beforeTime: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.alertCode) return

      this.$api
        .shipmentCustomerSettingAlertDetailApi({
          alertCode: this.alertCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .shipmentCustomerSettingAlertSaveApi({
          ...this.formData,
          shipmentCustomerSettingCode: this.shipmentCustomerSettingCode,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
